import React, { useEffect, useState } from "react";
import { activeDialogState } from "../../redux/slices/dialogsSlice";
import { useSelector } from "react-redux";
import { GlobalVariables } from "../../GlobalVariables";
import { ReduxUpdater } from "../../redux/ReduxUpdater";
import VanillaCalendar from "../components/elements/Forms/VanillaCalendar";

const DatepickerDialog = () => {
    const currentActiveDialogState =  useSelector(activeDialogState);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        // Optional: close on ESC
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") setOpen(false);
        }; 
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    useEffect(() => {
        setOpen(currentActiveDialogState === 'datePicker');
    }, [currentActiveDialogState]);

    const handleClose = () => {
        ReduxUpdater.currentDialog = null;
    };

    const now = new Date();
    const lastMonth = new Date();
    lastMonth.setDate(0);
    lastMonth.setDate(1);

    var selectedDateArr = [now.getFullYear(), now.getMonth(), now.getDay()];
    if (GlobalVariables.dialogConfig?.selectedDates && GlobalVariables.dialogConfig?.selectedDates.length > 0) {
        if (typeof GlobalVariables.dialogConfig?.selectedDates[0] === 'string') {
            selectedDateArr = GlobalVariables.dialogConfig?.selectedDates[0].split('-').map(o => parseInt(o)-1);
        }
    }

    return (
        <div>
            {open && (
                <div className="hs-overlay fixed inset-0 z-[60] overflow-y-auto bg-gray-900/50 p-4">
                    <div className="mx-auto mt-10 max-w-[fit-content]">
                        <div className="relative grid grid-cols-1 overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-200 md:grid-cols-12">
                            {/* Close */}
                            <button
                                type="button"
                                onClick={handleClose}
                                className="z-[61] absolute right-1 top-1 inline-flex size-6 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-amber-500"
                                aria-label="Close"
                            >
                                <svg className="size-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4"><path d="M18 6 6 18M6 6l12 12"/></svg>
                            </button>
    
                            <section className="col-span-12">
                                <VanillaCalendar
                                    id={`vanillaCalender-${Date.now()}`}
                                    config={{
                                        styles: {
                                            calendar: 'w-80 rounded-lg outline outline-1 border-border-default'
                                        },
                                        dateMin: GlobalVariables.dialogConfig.dateMin ?? lastMonth,
                                        dateMax: GlobalVariables.dialogConfig.dateMax ?? now,
                                        selectedDates: GlobalVariables.dialogConfig.selectedDates,
                                        selectedMonth: selectedDateArr[1] as 0|1|2|3|4|5|6|7|8|9|10|11|undefined,
                                        onClickDate: (c, e) => {
                                            GlobalVariables.dialogConfig.dateMin = undefined;
                                            GlobalVariables.dialogConfig.dateMax = undefined;
                                            GlobalVariables.dialogConfig.onClickDate(c, e);
                                        },
                                    }}
                                />
                            </section>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DatepickerDialog;
